import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const NfsServerIcon = createSvgIcon(
 <svg
  fill="currentColor"
  height="800px"
  width="800px"
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 472.615 472.615"
  xmlSpace="preserve">
  <g>
   <g>
    <polygon
     points="309.305,42.754 335.259,16.792 321.336,2.869 271.615,52.6 321.336,102.321 335.259,88.397 309.308,62.446 
			413.538,62.446 413.538,190.446 433.231,190.446 433.231,42.754 		"
    />
   </g>
  </g>
  <g>
   <g>
    <polygon
     points="151.279,370.263 137.356,384.186 163.31,410.147 59.077,410.147 59.077,282.147 39.385,282.147 39.385,429.839 
			163.307,429.839 137.356,455.792 151.279,469.715 201,419.993 		"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M236.308,98.478V0.016H0v98.462h59.077v9.846H0v98.462h59.077v19.66H39.385v19.692h157.539v-19.692h-19.692v-19.66h59.077
			v-98.462h-59.077v-9.846H236.308z M177.231,39.368h19.692v19.692h-19.692V39.368z M39.385,59.061V39.368h59.077v19.692H39.385z
			 M39.385,167.368v-19.692h59.077v19.692H39.385z M157.538,226.445H78.769v-19.66h78.769V226.445z M157.538,167.368h-19.692
			v-19.692h19.692V167.368z M157.538,108.324H78.769v-9.846h78.769V108.324z M157.538,59.061h-19.692V39.368h19.692V59.061z
			 M196.923,147.676v19.692h-19.692v-19.692H196.923z"
    />
   </g>
  </g>
  <g>
   <g>
    <path
     d="M472.615,324.939v-98.462H236.308v98.462h59.077v9.846h-59.077v98.461h59.077v19.66h-19.692v19.692h157.538v-19.692
			h-19.692v-19.66h59.077v-98.461h-59.077v-9.846H472.615z M413.538,265.83h19.692v19.692h-19.692V265.83z M275.692,285.522V265.83
			h59.077v19.692H275.692z M275.692,393.83v-19.692h59.077v19.692H275.692z M393.846,452.907h-78.769v-19.66h78.769V452.907z
			 M393.846,393.83h-19.692v-19.692h19.692V393.83z M393.846,334.786h-78.769v-9.846h78.769V334.786z M393.846,285.522h-19.692
			V265.83h19.692V285.522z M433.231,374.138v19.692h-19.692v-19.692H433.231z"
    />
   </g>
  </g>
 </svg>,
 "NfsServer"
);
